







































/* eslint-disable */
import { Component, Prop, Vue } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import Details from "./Details.vue";
import DiscardModal from "./DiscardModal.vue";
import Keys from "./Keys.vue";

@Component({
  components: {
    Details,
    // Log,
    DiscardModal,
    Keys, // @MOFA: I guess you can comment out this as well
  },
})
export default class EditDevice extends Vue {
  @Prop() readonly value!: boolean;
  private user = {
    firstName: "",
    lastName: "",
    extension: "",
    description: "",
    accountId: null,
    accountStatus: false,
    ipv4Address: "",
    netMask:"",
    gateway:"",
    altIpv4Address:"",
    altNetMask:"",
    altGateway:"",
    email:"",
    location:"",
  };
  private title = "";
  private tab = "";
  // @MOFA: You can hide the keys tab here
  private tabs = [
    { tab: "Details", content: "Details" },
    { tab: "Keys", content: "Keys" },
  ];
  private discardModalFlag = false;
  private triggerDiscardModal = false;

  get show() {
  //    console.log("edit dev show")
    return this.value;
  }

  set show(value: boolean) {
    EventBus.$emit("closeEditDeviceModal", value);
  }

  created() {
    EventBus.$off('openEditDeviceModal')
    EventBus.$off('closeDiscardModal')
    EventBus.$off('triggerDiscardModal')

    EventBus.$on("openEditDeviceModal", (user: any) => {
      this.triggerDiscardModal = false;
      this.title = `Edit device for ${user.firstName} ${user.lastName}`;
      this.user = {
        firstName: user.firstName,
        lastName: user.lastName,
        extension: user.extension,
        description: user.description,
        accountId: user.accountId,
        accountStatus: user.accountStatus,
        ipv4Address: user.ipv4Address,
        netMask:user.netMask,
        gateway:user.gateway,
        altIpv4Address:user.altIpv4Address,
        altNetMask:user.altNetMask,
        altGateway:user.altGateway,
        email:user.email,
        location:user.location,
      };
      this.tab = "Details";
    });

    EventBus.$on("closeDiscardModal", (value: boolean) => {
      this.discardModalFlag = value;
    });

    EventBus.$on("triggerDiscardModal", (value: boolean) => {
      this.triggerDiscardModal = value;
    });
  }


  // close modal and clear input fields
  private cancel(): void {
    if (this.triggerDiscardModal) {
      //show discard modal
      this.discardModalFlag = true;
    } else {
      this.tab = "Details";
      this.show = false;
      this.user = {
        firstName: "",
        lastName: "",
        extension: "",
        description: "",
        accountId: null,
        accountStatus: false,
        ipv4Address: "",
        netMask:"",
        gateway:"",
        altIpv4Address:"",
        altNetMask:"",
        altGateway:"",
        email:"",
        location:"",
      };
    }
    EventBus.$emit("LogSocketClose", null);
  }
}
